import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import ApprovedIcons from '@/icons/ApprovedIcons'
import PendingIcons from '@/icons/PendingIcons'
import RejectedIcons from '@/icons/RejectedIcons'
import { getDayOffSummary } from '@/modules/Dayoffs/services'
import { DayOffSummary } from '@/modules/Dayoffs/types/response'
import useAuthStore from '@/stores/useAuthStore'
import { IPermissionProps } from '@/types/shared'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Typogaphy } from 'vnetwork-ui'

import { QUERY_KEYS } from '@/constants/reactQueryKeys'

const Statistical: React.FC<IPermissionProps> = () => {
    const { employee } = useAuthStore()
    const { t } = useTranslation()
    const { data, renderState } = useQueryWithHandler({
        queryKey: [QUERY_KEYS.DAY_OFF_SUMMARY, employee?.employee_id],
        queryFn: async () => {
            const result = await getDayOffSummary()
            return result
        },
    })
    const stateComponent = renderState()
    if (stateComponent) return stateComponent

    const summaryItems: {
        key?: keyof DayOffSummary
        label: string
        icon: React.ReactNode
        value?: number
    }[] = [
        {
            label: t('dayoff-valid-leave'),
            icon: <ApprovedIcons />,
            value: employee?.employee_day_off_left ?? 0,
        },
        {
            key: 'pending_total',
            label: t('dayoff-pending-total'),
            icon: <PendingIcons />,
        },
        {
            key: 'rejected_total',
            label: t('dayoff-rejected-total'),
            icon: <RejectedIcons />,
        },
    ]

    return (
        <div className="grid lg:grid-cols-3 grid-cols-1 gap-2 mt-2">
            {summaryItems.map(({ key, label, icon, value }) => (
                <div key={key ?? label} className="p-4 bg-white rounded-lg">
                    <Typogaphy size="medium" className="text-primary">
                        {label}
                    </Typogaphy>
                    <div className="flex items-center gap-2 mt-2">
                        {icon}
                        <span className="text-xl font-semibold">
                            {value ?? data?.result?.[key!] ?? 0}
                        </span>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default Statistical
